import { ElementsList } from './types';

export const MIXPANEL_EVENT_NAMES: Record<ElementsList, string> = {
    [ElementsList.DOWNLOAD_ALL]:
        'Logo Maker - Post Order Page - Download All Clicked',
    [ElementsList.CREATE_NEW]:
        'Logo Maker - Post Order Page - Create New Variation Clicked',
    [ElementsList.UPGRADE_NOW]:
        'Logo Maker - Post Order Page - Upgrade Now Clicked',
    [ElementsList.PRO_PACKAGE_DETAILS]:
        'Logo Maker - Post Order Page - Pro Package Description Clicked',
    [ElementsList.UPGRADE_PRO_LOGO]:
        'Logo Maker - Post Order Page - Upgrade My Logo - Upgrade Clicked',
    [ElementsList.DOWNLOAD_SAMPLE_KIT]:
        'Logo Maker - Post Order Page - Download Sample Kit',
    [ElementsList.HOW_FIVERR_WORKS]:
        'Logo Maker - Post Order Page - How Fiverr Works Clicked',
    [ElementsList.SELLER_NAME]:
        'Logo Maker - Post Order Page - Seller Name Clicked',
    [ElementsList.GIGS_CAROUSEL]:
        'Logo Maker - Post Order Page - Gigs Carousel Clicked',
    [ElementsList.QUIZ_PROJECT]:
        'Logo Maker - Post Order Page - Project Clicked',
    [ElementsList.QUIZ_PROJECT_SERVICE]:
        'Logo Maker - Post Order Page - Project Service Clicked',
    [ElementsList.QUIZ_EDIT_PROJECT]:
        'Logo Maker - Post Order Page - Edit Project List Clicked',
    [ElementsList.QUIZ_CONTINUE]:
        'Logo Maker - Post Order Page - Show Services by Interests',
    [ElementsList.NEW_LOGO]:
        'Logo Maker - Post Order Page - Create New Logo Clicked',
    [ElementsList.SPECIAL_VARIATION]:
        'Logo Maker - Post Order Page - Download Special Variation',
    [ElementsList.GET_APP]: 'Logo Maker - Post Order Page - Get App Clicked',
} as const;
